import type { UpdateReservedUsernamesBody } from '@planuze/admin-contracts';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getReservedUsernames, updateReservedUsernames } from '../lib/reserved-usernames-api.js';

/* Hooks dos @username reservados (ADR-0730). Alimentam o card de gestão na Platform Settings. */

export function useReservedUsernames() {
  return useQuery({ queryKey: ['reserved-usernames'], queryFn: () => getReservedUsernames() });
}

export function useUpdateReservedUsernames() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body: UpdateReservedUsernamesBody) => updateReservedUsernames(body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['reserved-usernames'] });
    },
  });
}
